"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _material = require("@mui/material");

var _services = require("@alycecom/services");

var _ui = require("@alycecom/ui");

var PasswordSetting = function PasswordSetting(_ref) {
  var isLoading = _ref.isLoading,
      errors = _ref.errors,
      onReset = _ref.onReset,
      onSave = _ref.onSave;

  var _GlobalMessage$useGlo = _services.GlobalMessage.useGlobalMessage(),
      isSnackbarOpen = _GlobalMessage$useGlo.isSnackbarOpen;

  var isFormDisabled = isLoading || isSnackbarOpen;

  var _useState = (0, _react.useState)(''),
      _useState2 = (0, _slicedToArray2.default)(_useState, 2),
      currentPassword = _useState2[0],
      setCurrentPassword = _useState2[1];

  var _useState3 = (0, _react.useState)(''),
      _useState4 = (0, _slicedToArray2.default)(_useState3, 2),
      newPassword = _useState4[0],
      setNewPassword = _useState4[1];

  var _useState5 = (0, _react.useState)(''),
      _useState6 = (0, _slicedToArray2.default)(_useState5, 2),
      confirmNewPassword = _useState6[0],
      setConfirmNewPassword = _useState6[1];

  var isNewPasswordInvalid = (0, _react.useMemo)(function () {
    if (newPassword.length > 0 && confirmNewPassword.length > 0) {
      return newPassword !== confirmNewPassword || !!errors.newPasswordConfirmation;
    }

    return !!errors.newPasswordConfirmation;
  }, [errors, newPassword, confirmNewPassword]);
  var newPasswordError = (0, _react.useMemo)(function () {
    if (isNewPasswordInvalid) {
      return errors.new_password_confirmation ? errors.new_password_confirmation : 'The new password confirmation and new password must match.';
    }

    return null;
  }, [errors, isNewPasswordInvalid]);
  var handleChangePassword = (0, _react.useCallback)(function () {
    onSave({
      currentPassword,
      newPassword,
      newPasswordConfirmation: confirmNewPassword
    });
  }, [confirmNewPassword, currentPassword, newPassword, onSave]);
  return /*#__PURE__*/_react.default.createElement(_material.Grid, {
    container: true,
    direction: "column"
  }, /*#__PURE__*/_react.default.createElement("form", null, /*#__PURE__*/_react.default.createElement(_material.Grid, {
    item: true,
    xs: 5
  }, /*#__PURE__*/_react.default.createElement(_material.Box, {
    mb: 3
  }, /*#__PURE__*/_react.default.createElement(_material.TextField, {
    id: "personal-settings-settings-current-password",
    variant: "outlined",
    label: "Your current password",
    fullWidth: true,
    type: "password",
    error: errors.currentPassword,
    helperText: errors.currentPassword,
    value: currentPassword,
    onChange: function onChange(e) {
      return setCurrentPassword(e.target.value);
    },
    placeholder: "Your current password",
    disabled: isFormDisabled
  }))), /*#__PURE__*/_react.default.createElement(_material.Grid, {
    item: true,
    xs: 5
  }, /*#__PURE__*/_react.default.createElement(_material.Box, {
    mb: 3
  }, /*#__PURE__*/_react.default.createElement(_material.TextField, {
    id: "personal-settings-settings-new-password",
    variant: "outlined",
    label: "Your new password",
    fullWidth: true,
    type: "password",
    error: errors.newPassword,
    helperText: errors.newPassword,
    value: newPassword,
    onChange: function onChange(e) {
      return setNewPassword(e.target.value);
    },
    placeholder: "Your new password",
    disabled: isFormDisabled
  }))), /*#__PURE__*/_react.default.createElement(_material.Grid, {
    item: true,
    xs: 5
  }, /*#__PURE__*/_react.default.createElement(_material.TextField, {
    id: "personal-settings-settings-confirm-new-password",
    variant: "outlined",
    label: "Confirm new password",
    fullWidth: true,
    type: "password",
    error: isNewPasswordInvalid,
    helperText: newPasswordError,
    value: confirmNewPassword,
    onChange: function onChange(e) {
      return setConfirmNewPassword(e.target.value);
    },
    placeholder: "Confirm new password",
    disabled: isFormDisabled
  })), /*#__PURE__*/_react.default.createElement(_material.Box, {
    mt: 2
  }, /*#__PURE__*/_react.default.createElement(_ui.ActionButton, {
    onClick: handleChangePassword,
    disabled: currentPassword.length === 0 || isFormDisabled
  }, "Save")), /*#__PURE__*/_react.default.createElement(_material.Box, {
    mt: 2
  }, "If you can\u2019t remember your current password, you can", ' ', /*#__PURE__*/_react.default.createElement(_ui.LinkButton, {
    onClick: onReset,
    disabled: isFormDisabled,
    style: {
      display: 'inline-block'
    }
  }, "reset your password by email"))));
};

PasswordSetting.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  errors: _propTypes.default.object,
  isLoading: _propTypes.default.bool,
  onSave: _propTypes.default.func.isRequired,
  onReset: _propTypes.default.func.isRequired
};
PasswordSetting.defaultProps = {
  errors: {},
  isLoading: false
};
var _default = PasswordSetting;
exports.default = _default;